import { render, staticRenderFns } from "./AppStep2.vue?vue&type=template&id=4d4e0b58"
import script from "./AppStep2.vue?vue&type=script&lang=js"
export * from "./AppStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports